import React, {Component} from 'react';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from 'react-notification-system';
import CSVReader from 'react-csv-reader';
import $ from 'jquery';
import {_addNotification,_addNotificationError} from '../../../server/util';
import {get,postWithHeadersResponse} from "../../../server/actions";
import Slider from "react-slick";
const optionalFields=['ParentAltEmail','ParentMobileNumb','FreeLunchElig','ReducedPriceElig','EntryCode','ExitCode'];
let schoolId=0;

class DataSync extends Component {
    constructor(props){
        super(props);
        this.state={
            loading: false,
            mapFields:[],
            mainFields:[]

        }
        this.getDataSyncFieldMap=this.getDataSyncFieldMap.bind();
    }
    componentDidMount(){
        
        if(sessionStorage.getItem('ROLE')==='ROLE_SUPERADMIN'){
            schoolId=this.props.school._links.self.href.split('/').pop();
            this.setState({schoolName:'['+this.props.school.schoolName+']'})
        }
        else{
            schoolId=sessionStorage.getItem('SchoolId');
        }
        this.getDataSyncFieldMap();
        this._notificationSystem = this.refs.notificationSystem;
    }
    componentWillMount(){        
        
    }
    getDataSyncFieldMap=()=>{
        this.setState({loading: true});
        get('/dataSyncFieldMapping?mealSchoolId=' + schoolId + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            console.log('data', data);
            let _mainFields = [];
            let _mapFields=[];
            let notMapFieldCount=0
           Object.keys(data).forEach(fieldkey=>{
            _mainFields.push({reqField:fieldkey, mapField:data[fieldkey]});
            if(data[fieldkey].trim()!='')
                _mapFields.push(data[fieldkey].trim())
            else
                notMapFieldCount=notMapFieldCount+1;
            });
            if( Object.keys(data).length===notMapFieldCount)
                this.slider.slickGoTo(0);
            else
                this.slider.slickGoTo(1);

            this.setState({mainFields:_mainFields, loading:false});
            this.setState({mapFields:_mapFields});
        }).catch(
            (error) => {   
                this.setState({loading: false})             
                console.log('Get School data response', error)
            }
        );
    }
    handleForce=(fileContent)=>{
        console.log(fileContent);
        if(fileContent.length>0){
            this.setState({mapFields:fileContent[0]});
            this.slider.slickGoTo(1);
        } 
    }
    handleDarkSideForce=()=>{
        console.log();
    }
    onOptionChange=(e)=>{
       let controlIndex= e.target.getAttribute('data-rid');
       let mainFieldList= this.state.mainFields;
       mainFieldList[parseInt(controlIndex)].mapField=e.target.value;       
       this.setState({mainFields:mainFieldList});
    }
    onSaveSubmit=()=>{
        console.log(this.state.mainFields); 
        this.setState({loading: true})       
        let selecterList=document.querySelectorAll('select');
        let isValid=true;
        if(selecterList.length>0){
            selecterList.forEach(selectCtrl=>{
                let fieldName=selectCtrl.getAttribute('data-fname')
                if(optionalFields.includes(fieldName)===false){
                    if(selectCtrl.value==''){
                        isValid=false;
                    }
                }                
            })
        }
        if(isValid){
            let mainList={}
            this.state.mainFields.forEach(field=>{
                mainList[field.reqField]=field.mapField;
            })
            let headers = {
                'Content-Type': 'application/json'
            };
            postWithHeadersResponse('/dataSyncFieldMapping?mealSchoolId=' + schoolId + '&access_token=', JSON.stringify(mainList),headers).then((response) => {
                if (response.statusCode!==200) {               
                    throw Error(response.statusMessage);
                }
                console.log('response', response);
                return response;
            }).then(res => {
                this.setState({loading: false})
                _addNotification(res.statusMessage, this);
                return true;
            }).catch(
                (error) => {
                    this.setState({loading: false})
                     _addNotificationError(error.message,this);  
                     return false;             
                }
            )
        }else{
            this.setState({loading: false})
            _addNotificationError('Please map all the mandatory fields.',this);
            return false;
        }
    }
    render() {
        let settings = {
            dots: false,
            arrows: true,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: true,
            adaptiveHeight: true,
            schoolName:''
        
        };
        let optionItems = this.state.mapFields.map((item) =>
        <option value={item} >{item}</option>
    );
        return (
           
                 <section className="full-width clearfix  margin-top">
                 <NotificationSystem ref="notificationSystem"/>
                 <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>           
          
                <div className="container"> 
               {/*  <div className="col-md-8 col-sm-12 col-xs-12 createmenu-panel">
                    <div className="card">
                        <div class="card-header text-center">
                            <b>Command For Data Sync Process</b>
                        </div>
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item"><i>{' java -jar MMDataSync.jar schoolId='+sessionStorage.getItem('SchoolId')+' fileName=<fileName>.csv profile=prod'}</i></li>
                        </ul>              
                    </div> 

                </div> */}           
                    <div className="col-md-8 col-sm-12 col-xs-12 text-center createmenu-panel">
                    <div className="panel panel-primary">
                    <div class="panel-heading text-center">
                    <h3 class="panel-title">Fields Mapping For Data Sync {this.state.schoolName}</h3>
                    </div>
                    <Slider {...settings} ref={slider => (this.slider = slider)}  >
                    <div className="col-md-12">
                        <div className="col-md-7 col-md-offset-3 col-sm-12 col-xs-12 text-center">
                                        <label className="control-label">Upload Source File</label>
                                    </div>
                                    <div className="uploadFileInfo col-md-12 col-sm-12 col-xs-12 createmenu-file-group">                                        
                                    <div className="input-group col-md-7 col-md-offset-3 col-sm-12 col-xs-12">                            
                            <CSVReader cssClass="form-control"                           
                                onFileLoaded={this.handleForce}
                                onError={this.handleDarkSideForce}
                                inputId="ObiWan"
                            />  <button id="OpenUpload" className="input-group-addon" onClick={() => {
                                                    $('#ObiWan').click()
                                                }}><i
                                                    className="fa fa-upload"
                                                    aria-hidden="true"/>
                                                </button>
                            
                        </div>
                                        
                                    </div>
                        <div className="col-md-12">
                        <div className="clearfix"></div>
                                    <div className="col-md-12 col-sm-12 col-xs-12 createmenu-link-group">
                                        <p className="input-group col-md-9 col-md-offset-3 col-sm-12 col-xs-12 text-left">Upload source file to create mapping fields. Download&nbsp;<a
                                            href="https://s3.amazonaws.com/mealmanageordered/DataSyncSampleFile/Students.csv"
                                            download>Sample
                                            file</a>
                                        </p>
                                    </div>
                        </div>                        
                        </div>                        
                        <div className="col-md-12">
                        <form name="frmSetMap" ref={c => { this.form = c }} className=""  >
                        <ul class="list-group">
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                        <div className='row'>
                        <div className="col-md-5"><b>Destination Fields</b></div>
                        <div className="col-md-7"><b>Source Fields</b></div>
                        </div>
                        </li>
                        {this.state.mainFields.map((field,key)=>{
                        return( <li style={{padding: '3px', border: '1px solid #ddd'}}>
                        <div className='row'>
                        <div className="col-md-5">{field.reqField +(optionalFields.includes(field.reqField)===true ?'':' *')}</div>
                        <div className="col-md-7">
                       
                        <select name={'select-'+key} class="form-control" data-rid={key} data-fname={field.reqField}  value={field.mapField} 
                         onChange={this.onOptionChange} ><option value=''> Select </option>{optionItems}</select></div></div>
                        
                        </li>)   ;
                  })}
                  </ul>    </form>
                            <div class="col-md-12">
                            <input type="button" value="Save" className="btn btn-sm btn-primary" onClick={this.onSaveSubmit} />
                            
                            </div>
                            
                        </div>
                    </Slider>
                        </div>
                    </div>
                    </div>
                   </section>
                   
        );
    }
}
export default DataSync;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/DataSync/dataSync.jsx